import gql from 'graphql-tag';

export default gql`
  query merchGroupsByIds($merchGroupIds: [ID!]!) {
    merchGroupsByIds(merchGroupIds: $merchGroupIds) {
      id
      slug
      title
      parentMerchGroupCategory {
        slug
      }
      canonicalParentMerchGroupCategory {
        slug
      }
    }
  }
`;
